import { cn } from "@/lib/utils";
import { __ } from "@/i18n";

interface StepperProps {
  step: 1 | 2;
}

export function Stepper({ step }: StepperProps) {
  return (
    <div className="cy:flex cy:items-center cy:mb-6">
      {/* Step 1: always a numbered circle */}
      <div
        className={cn(
          "cy:flex cy:items-center cy:justify-center cy:w-7 cy:h-7 cy:rounded-full cy:text-xs cy:font-semibold cy:border cy:flex-shrink-0",
          step === 1
            ? "cy:bg-primary cy:text-white cy:border-primary"
            : "cy:bg-transparent cy:text-muted-foreground cy:border-gray-300"
        )}
      >
        1
      </div>

      {/* Connecting line — fixed width */}
      <div className="cy:h-px cy:flex-1 cy:mx-2 cy:bg-gray-300" />

      {/* Step 2: always a "Conformance status" pill */}
      <div
        className={cn(
          "cy:flex cy:items-center cy:justify-center cy:h-7 cy:px-3 cy:rounded-full cy:text-xs cy:font-semibold cy:border cy:flex-shrink-0",
          step === 2
            ? "cy:bg-primary cy:text-white cy:border-primary"
            : "cy:bg-transparent cy:text-muted-foreground cy:border-gray-300"
        )}
      >
      {__( 'Conformance status', 'accessibility-widget' )}
      </div>
    </div>
  );
}
